export default function (VirtualKeyboard) {
    return VirtualKeyboard.addLayout({
        code: 'ML-IN',
        name: 'Malayalam',
        normal: 'ൊ1234567890-ൃൌൈാീൂബഹഗദജഡോേ്ിുപരകതചടെംമനവലസ,.യ',
        shift: { 0: 'ഒ', 3: '്ര', 7: 'ക്ഷ', 9: '()ഃഋ', 14: 'ഔഐആഈഊഭങഘധഝഢഞഓഏഅഇഉഫറഖഥഛഠഎ', 39: 'ണ', 41: 'ഴളശഷ' },
        alt: { 1: '൧൨൩൪൫൬൭൮൯൦', 14: 'ൗ' },
        shift_alt: { 12: 'ൠ', 17: 'ൡ', 28: 'ഌ' }
    })
}
